import { Control, FieldValues, Path, useController } from 'react-hook-form';
import TextArea, { TextAreaProps } from '../ui/TextArea';

interface TextAreaFieldProps<T extends FieldValues> extends TextAreaProps {
  control: Control<T>;
  name: Path<T>;
}

function TextAreaField<T extends FieldValues>({
  control,
  name,
  isDisabled,
  ...props
}: TextAreaFieldProps<T>) {
  const {
    field,
    fieldState: { error, invalid },
    formState: { isSubmitting },
  } = useController({
    name,
    control,
  });

  return (
    <TextArea
      {...props}
      onChange={field.onChange}
      onBlur={field.onBlur}
      value={field.value}
      name={field.name}
      errorMessage={error?.message}
      isDisabled={isDisabled}
      isReadOnly={isSubmitting}
      isInvalid={invalid}
      validationBehavior="aria"
    />
  );
}

export default TextAreaField;
